<template>
    <div id="app">
        <div id="header">
          <nav class="navbar navbar-expand-sm mb-2">
            <!-- Brand/logo -->
            <a class="navbar-brand" href="/home">
                <svg-icon icon-class="logo-a" style="color: #498de5; width:33.46px; height:32.4px"></svg-icon>
            </a>
            <!-- navbar left -->
            <ul class="navbar-nav ml-auto">
                <template v-if="$store.getters.isAuthenticated">
                  <li class="nav-item">
                    <logout-button link_class="nav-link" />
                  </li>
                </template>
                <template v-else>
                  <router-link to="/login" class="nav-link" >Connexion</router-link>
                </template>
            </ul>
          </nav>
        </div>
        <div  class="container" id="content-wrapper">
          <router-view/>
        </div>
        <div id="footer">
        </div>
        <flash-message class="alert alert-flash"></flash-message>
    </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

</style>